/*
 * Enth Projects — Cart linked items
 * ---------------------------------------------------------------------------
 * Crate add-ons carry `_artwork_id` / `_pairing_id` line item properties.
 * They cannot be removed or quantity-changed independently. Removing the
 * parent artwork cascades removal of its linked crate line(s).
 */
(function () {
  'use strict';

  var LINKED_PROP = '_artwork_id';
  var PAIRING_PROP = '_pairing_id';

  function fetchCart() {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return fetch(root + 'cart.js').then(function (response) {
      return response.json();
    });
  }

  function getLineElement(line) {
    return (
      document.getElementById('CartItem-' + line) ||
      document.getElementById('CartDrawer-Item-' + line)
    );
  }

  function getProp(item, key) {
    if (!item || !item.properties) return '';
    var value = item.properties[key];
    return value != null && value !== '' ? String(value) : '';
  }

  function isLinkedCrate(item) {
    return !!getProp(item, LINKED_PROP);
  }

  function getParentContext(cart, lineNum) {
    var item = cart.items[lineNum - 1];
    var lineEl = getLineElement(lineNum);
    var pairingId = getProp(item, PAIRING_PROP);

    if (!pairingId && lineEl && lineEl.dataset.enthPairingId) {
      pairingId = lineEl.dataset.enthPairingId;
    }

    return {
      item: item,
      pairingId: pairingId,
      productId: item ? String(item.product_id) : '',
    };
  }

  function getLinkedCrateLines(cart, parentContext) {
    var lines = [];

    cart.items.forEach(function (item, index) {
      if (!isLinkedCrate(item)) return;

      if (parentContext.pairingId && getProp(item, PAIRING_PROP) === parentContext.pairingId) {
        lines.push(index + 1);
        return;
      }

      if (!parentContext.pairingId && getProp(item, LINKED_PROP) === parentContext.productId) {
        lines.push(index + 1);
      }
    });

    if (!lines.length && parentContext.pairingId) {
      document
        .querySelectorAll('[data-enth-linked-crate][data-enth-pairing-id="' + parentContext.pairingId + '"]')
        .forEach(function (el) {
          var match = el.id && el.id.match(/(\d+)$/);
          if (match) lines.push(parseInt(match[1], 10));
        });
    }

    return lines;
  }

  function findLineByKey(cart, key) {
    for (var i = 0; i < cart.items.length; i += 1) {
      if (cart.items[i].key === key) {
        return i + 1;
      }
    }
    return 0;
  }

  function patchCartItems() {
    var CartItemsClass = customElements.get('cart-items');
    if (!CartItemsClass || CartItemsClass.prototype.updateQuantity._enthLinkedPatched) {
      return !!CartItemsClass;
    }

    var originalUpdate = CartItemsClass.prototype.updateQuantity;

    CartItemsClass.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      var self = this;
      var lineNum = parseInt(line, 10);
      var nextQty = parseInt(quantity, 10);

      return fetchCart()
        .then(function (cart) {
          var item = cart.items[lineNum - 1];
          if (!item) {
            return originalUpdate.call(self, line, quantity, event, name, variantId);
          }

          if (isLinkedCrate(item)) {
            if (nextQty !== item.quantity) {
              self.resetQuantityInput(line);
              self.updateLiveRegions(
                line,
                'This item is included with your artwork and cannot be removed separately.'
              );
              return null;
            }
            return originalUpdate.call(self, line, quantity, event, name, variantId);
          }

          if (nextQty !== 0) {
            return originalUpdate.call(self, line, quantity, event, name, variantId);
          }

          var parentContext = getParentContext(cart, lineNum);
          var parentKey = item.key;
          var crateLines = getLinkedCrateLines(cart, parentContext);

          if (!crateLines.length) {
            return originalUpdate.call(self, line, quantity, event, name, variantId);
          }

          function removeLinkedCratesThenParent() {
            return fetchCart().then(function (freshCart) {
              var pendingCrates = getLinkedCrateLines(freshCart, parentContext);

              if (pendingCrates.length) {
                var highestCrateLine = Math.max.apply(null, pendingCrates);
                return originalUpdate
                  .call(self, highestCrateLine, 0, event, name, variantId)
                  .then(removeLinkedCratesThenParent);
              }

              var parentLine = findLineByKey(freshCart, parentKey);
              if (!parentLine) {
                return null;
              }

              return originalUpdate.call(self, parentLine, 0, event, name, variantId);
            });
          }

          return removeLinkedCratesThenParent();
        })
        .catch(function (err) {
          console.error('[enth-cart-linked-items]', err);
          return originalUpdate.call(self, line, quantity, event, name, variantId);
        });
    };

    CartItemsClass.prototype.updateQuantity._enthLinkedPatched = true;
    return true;
  }

  function init() {
    if (patchCartItems()) return;

    if (typeof customElements.whenDefined === 'function') {
      customElements.whenDefined('cart-items').then(patchCartItems);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
